import React, { useCallback } from 'react'
import { Grid } from 'semantic-ui-react'
import DropDown from '@commonComponents/formComponents/CustomDropDown'
import DeleteIcon from '@commonComponents/deleteIcon'
import InputField from '@commonComponents/formComponents/CustomInputField'

const AddGuaranteeDetailsForm = ({dataSource: {id,amount,currency,eoriNo,accessCode,office},translate,currencyList,guaranteeAmtList=[],guaranteeOfficeList,onChange,onSelect,onBlur,tableName,deleteData}) => {
  const onChangeHandler=useCallback(({target:{value,name}})=>onChange(id,tableName,{[name]:value}),[tableName,id,onChange])
  const onDropDownChange=useCallback((e, {value,name})=>onSelect(id,tableName,{[name]:value,id}),[tableName,id,onSelect])
  const onBlurHandler=useCallback(({target:{value,name}})=>onBlur(tableName,{[name]:value,id}),[tableName,id,onBlur])
  
  return (
    <div  className="formContainer">   
    <Grid.Row>
      <Grid.Column>
      <InputField
          id={`addGuaranteeAmount${id}`}
          name="amount"
          type="number"
          label={translate("GUARANTEE_AMOUNT", {ns:["default", "parties"]})}
          clearInput={false}
          onChange={onChangeHandler}
          onBlur={onBlurHandler}
           value={amount}
        />
     
      </Grid.Column>
      <Grid.Column>
        <DropDown
          id={`addGuaranteecurrency${id}`}
          label={translate("CURRENCY", {ns:["default", "parties"]})}
          name="currency"
          labelClass="text-none"
          data={currencyList}
          onChange={onDropDownChange}
          value={currency}
          text={currency}
          />
      </Grid.Column>
      <Grid.Column>
           <InputField
          id={`addGuaranteeIdentity${id}`}
          name="eoriNo"
          type="text"
          label={translate("GUARANTEE_IDENTIFICATION", {ns:["default", "parties"]})}
          clearInput={false}
          onChange={onChangeHandler}
          onBlur={onBlurHandler}
           value={eoriNo}
        />
      </Grid.Column>
      <Grid.Column>
          <InputField
          id={`accessCode${id}`}
          name="accessCode"
          type="text"
          label={translate("ACCESS_CODE", {ns:["default", "parties"]})}
          clearInput={false}
          onChange={onChangeHandler}
          onBlur={onBlurHandler}
          value={accessCode}
        />
      </Grid.Column>
      <Grid.Column>
      <DropDown
          id={`guranteeOffice${id}`}
          label={translate("GUARANTEE_OFFICE", {ns:["default", "parties"]})}
          name="office"
          direction="left"
          labelClass="text-none"
          data={guaranteeOfficeList}
          onChange={onDropDownChange}
          value={office}
          text={office}
          />
        
      </Grid.Column>
  
    </Grid.Row>
    <div className="actionbtns">
    <DeleteIcon onClick={()=>deleteData(id,tableName)} />
    </div>
    </div>
  )
}
AddGuaranteeDetailsForm.defaultProps = {
    translate:(value)=>value
  }
export default React.memo(AddGuaranteeDetailsForm)
